import { Box } from '@mui/material';
import { PageTitle } from './components/PageTitle';
import { PatientList } from './components/PatientList';
import { TreatmentPeriod } from './components/TreatmeanPeriod';
import { ProgressPortraitTimeline } from './components/ProgressPortraitTimeline';
import { ProgressPortraitProvider } from './components/ProgressPortraitProvider';
import { Legend } from './components/Legend';

export const ProgressPortraitPage = () => {
  return (
    <ProgressPortraitProvider>
      <Box
        px={8}
        py={10}
        sx={{
          backgroundColor: '#f7f8fb',
          display: 'flex',
          flexDirection: 'column',
        }}
      >
        <PageTitle />
        <Box mt={10}>
          <PatientList />
        </Box>
        <Box
          sx={{
            mt: 10,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            position: 'relative',
          }}
        >
          <TreatmentPeriod />
          <Legend />
        </Box>
        <Box mt={10} sx={{ overflow: 'auto' }} className='hide-scrollbar'>
          <ProgressPortraitTimeline />
        </Box>
      </Box>
    </ProgressPortraitProvider>
  );
};
